
import { createElement } from "/elements_functions/new_elements.js";
import { makeNewButton } from "/buttons_functions/custom_button_functions.js";

export function createPlus18Screen(elementToBlur=null) {
    const black18Screen = createElement('div', null, ['plus-18-screen']);

    const black18ScreenInnerGroup = createElement('div', null, ['plus-18-screen-inner-group']);

    const black18ScreenExplanation = createElement('p', null, ['plus-18-screen-explanation']);
    black18ScreenExplanation.innerText = "To view this content, you need to be 18 years old or above."
    const black18ScreenQuestion = createElement('p', null, ['plus-18-screen-question']);
    black18ScreenQuestion.innerText = "Are you over 18?"

    const black18ScreenButtonGroup = createElement('div', null, ['plus-18-screen-button-group']);

    const black18ScreenButton = createElement('button', null, ['plus-18-screen-button']);
    black18ScreenButton.addEventListener('click', () => {
        if(elementToBlur!==null && elementToBlur!==undefined) {
            elementToBlur.classList.remove('blurred');
            black18Screen.remove();
        }
    });

    makeNewButton(black18ScreenButton, 'gray', 'black', 'Yes, I am.', 'lighten');

    black18ScreenButtonGroup.append(black18ScreenButton);

    black18ScreenInnerGroup.append(black18ScreenExplanation);
    black18ScreenInnerGroup.append(black18ScreenQuestion);
    black18ScreenInnerGroup.append(black18ScreenButtonGroup);

    black18Screen.append(black18ScreenInnerGroup);

    black18Screen.black18ScreenInnerGroup = black18ScreenInnerGroup;
    black18Screen.black18ScreenExplanation = black18ScreenExplanation;
    black18Screen.black18ScreenQuestion = black18ScreenQuestion;
    black18Screen.black18ScreenButton = black18ScreenButton;

    if(elementToBlur!==null && elementToBlur!==undefined) {
        elementToBlur.classList.add('blurred');
    }

    black18Screen.createGoBackButton = () => createGoBackButton(black18Screen);

    black18Screen.create18WarningIconInBeginning = () => create18WarningIconInBeginning(black18Screen);
    black18Screen.create18WarningIconInEnd = () => create18WarningIconInEnd(black18Screen);

    return black18Screen;
    
}

function createGoBackButton(black18Screen) {
    const black18ScreenInnerGroup = black18Screen.black18ScreenInnerGroup;
    const black18ScreenButton = black18Screen.black18ScreenButton;
    
    const buttonRemoved = !black18ScreenInnerGroup.contains(black18ScreenButton);
    
    const buttonGoBack = createElement('button', null, ['plus-18-screen-go-back-button']);
    makeNewButton(buttonGoBack, 'gray', 'black', 'No, take me back.', 'lighten');

    buttonGoBack.addEventListener('click', () => {
        if (document.referrer !== '')
            history.back();
        else
            window.location.href = "/";
    });

    if(buttonRemoved)
        black18ScreenInnerGroup.append(buttonGoBack);
    else
        black18ScreenButton.insertAdjacentElement('beforebegin', buttonGoBack);
}

function create18WarningIcon() {
    const warning18Icon = createElement('div', null, ['plus-18-screen-icon']);
    const warning18Img = createElement('img', null, null);
    warning18Img.src = "/images/icons/plus_18.png";

    warning18Icon.imageElement = warning18Img;

    warning18Icon.append(warning18Img);
    return warning18Icon;
}

function create18WarningIconInBeginning(black18Screen) {
    const warning18Icon = create18WarningIcon();

    black18Screen.black18ScreenInnerGroup.insertAdjacentElement('afterbegin', warning18Icon);
    addShapeFunctions(black18Screen, warning18Icon);
}

function create18WarningIconInEnd(black18Screen) {
    const warning18Icon = create18WarningIcon();

    black18Screen.black18ScreenInnerGroup.insertAdjacentElement('beforeend', warning18Icon);
    addShapeFunctions(black18Screen, warning18Icon);
}

//----------------Shape functions-------------------\\

function addShapeFunctions(black18Screen, icon) {
    black18Screen.makeIconRound = () => makeIconRound(icon);
    black18Screen.makeIconRoundedSquare = () => makeIconRoundedSquare(icon);
    black18Screen.makeIconRhombus = () => makeIconRhombus(icon);
}

function makeIconRound(icon) {
    icon.style.aspectRatio = "1 / 1";
    icon.style.borderRadius = "50%";
    icon.imageElement.style.width = "110%";
}

function makeIconRoundedSquare(icon) {
    icon.style.aspectRatio = "1 / 1";
    icon.style.borderRadius = "15%";
}

function makeIconRhombus(icon) {
    icon.style.aspectRatio = "1 / 1";
    icon.style.transform = "rotate(45deg)";
    icon.imageElement.style.transform = "rotate(-45deg)";
    icon.imageElement.style.width = "140%";
}